module.exports = __webpack_public_path__ + "static/media/8.d8ecafad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Carousel/CarouselMedia/8.jpg
// module id = 169
// module chunks = 0